var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.vacancy
    ? _c(
        "a",
        {
          staticClass:
            "flex flex-col bg-white p-[30px] group hover:bg-brown-400 transition-colors",
          attrs: { href: _vm.vacancyLink }
        },
        [
          _c("v-clamp", {
            staticClass:
              "text-brown-400 h-[78px] lg:h-[104px] text-30 leading-snug lg:text-30  font-regular pb-16 mb-16 border-b border-gray-200 group-hover:border-orange group-hover:text-white transition-colors",
            attrs: { autoresize: "", "max-lines": 2 },
            domProps: { innerHTML: _vm._s(_vm.vacancy.functie) }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "h-[80px]" }, [
            _vm.vacancy.locatie
              ? _c(
                  "div",
                  {
                    staticClass: "flex flex-wrap gap-16 items-center mb-[20px]"
                  },
                  [
                    _c("span", {
                      staticClass: "fas fa-bullseye text-orange text-30"
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "text-20 font-regular group-hover:text-white transition-colors"
                      },
                      [_vm._v(_vm._s(_vm.vacancy.locatie))]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.vacancy.dienst && _vm.vacancy.dienst
              ? _c(
                  "div",
                  { staticClass: "flex flex-wrap gap-16 items-center" },
                  [
                    _c("span", {
                      staticClass: "fas fa-user text-orange text-30"
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "text-20 font-regular group-hover:text-white transition-colors"
                      },
                      [_vm._v(_vm._s(_vm.vacancy.dienst))]
                    )
                  ]
                )
              : _vm._e()
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }